<script lang="ts" setup>
import { computed } from 'vue'

import { ToastColorEnum } from './types'

const props = defineProps<{
  isOpen: boolean
  title: string
  message: string
  color: ToastColorEnum
}>()
const emit = defineEmits(['close-toast'])

function getClasses(body: boolean): string[] {
  if (props.color === '') {
    return []
  }
  const classes = [(body ? 'text-' : 'bg-') + props.color]
  if (!body) {
    classes.push('text-white')
  }
  return classes
}
const headerClasses = computed(() => getClasses(false))
const bodyClasses = computed(() => getClasses(true))
</script>

<template>
  <div
    v-if="isOpen"
    class="sancare-toast toast"
    :class="{show: isOpen}"
  >
    <div
      class="toast-header"
      :class="[headerClasses]"
    >
      <span>{{ title }}</span>
      <button
        type="button"
        class="ms-auto btn-close"
        data-dismiss="toast"
        aria-label="Close"
        @click.prevent="emit('close-toast')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div
      class="toast-body"
      :class="[bodyClasses]"
    >
      {{ message }}
    </div>
  </div>
</template>
